import { getRequestOptionDemoMode } from '@/utils/demoMode';
import { request } from 'umi';

/**
 * 獲取 A1 (Aware) insights 每日數據
 * @param params
 * @param options
 * @returns
 */
export const getA1InsightsApi = async (
  params: API.A1InsightsGetParameters,
  options?: API.RequestOptions,
) => {
  return request<API.A1InsightsList>('/api/insights/a1/daily', {
    method: 'POST',
    data: params,
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

/**
 * 獲取 A1 排名數據
 * @param params
 * @param options
 * @returns
 */
export const getA1RanklistApi = async (
  params: API.A1RanklistRequest,
  options?: API.RequestOptions,
) => {
  return request<API.A1RanklistResponse>('/api/insights/a1/ranklist', {
    method: 'POST',
    data: params,
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

// A1密度報告API請求
export async function getA1DensityReport(
  params: {
    start_date?: string;
    end_date?: string;
    client_id?: string;
  },
  options?: Record<string, any>,
) {
  return request<API.A1DensityReportItem[]>('/api/insights/a1/density_report', {
    method: 'POST',
    data: params,
    ...(options || {}),
  });
}

/**
 * 獲取 A1 流量來源資料
 * @param params
 * @param options
 * @returns
 */
export const getA1TrafficSourceApi = async (
  params: API.A1TrafficSourceRequest,
  options?: API.RequestOptions,
) => {
  return request<API.A1TrafficSourceResponse>('/api/insights/a1/traffic_source', {
    method: 'POST',
    data: params,
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

/**
 * 獲取 A1 Dashboard 數據
 * @param params
 * @param options
 * @returns
 */
export const getA1DashboardApi = async (
  params: {
    start_date: string;
    end_date: string;
    client_id?: string;
  },
  options?: API.RequestOptions,
) => {
  return request<API.A1DashboardResponse>('/api/ga4bg/a1-dashboard', {
    method: 'POST',
    data: params,
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

/**
 * 獲取 A2 Dashboard 數據
 * @param params
 * @param options
 * @returns
 */
export const getA2DashboardApi = async (
  params: {
    start_date: string;
    end_date: string;
    client_id?: string;
  },
  options?: API.RequestOptions,
) => {
  return request<API.A2DashboardResponse>('/api/ga4bg/a2-dashboard', {
    method: 'POST',
    data: params,
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

/**
 * 獲取 A3 Dashboard 數據
 * @param params
 * @param options
 * @returns
 */
export const getA3DashboardApi = async (
  params: {
    start_date: string;
    end_date: string;
    client_id?: string;
  },
  options?: API.RequestOptions,
) => {
  return request<API.A3DashboardResponse>('/api/ga4bg/a3-dashboard', {
    method: 'POST',
    data: params,
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

/**
 * 獲取 A4 Dashboard 數據
 * @param params
 * @param options
 * @returns
 */
export const getA4DashboardApi = async (
  params: {
    start_date: string;
    end_date: string;
    client_id?: string;
  },
  options?: API.RequestOptions,
) => {
  return request<any>('/api/ga4bg/a4-dashboard', {
    method: 'POST',
    data: params,
    ...options,
    ...getRequestOptionDemoMode(),
  });
};

/**
 * 獲取 A5 Dashboard 數據
 * @param params
 * @param options
 * @returns
 */
export const getA5DashboardApi = async (
  params: {
    start_date: string;
    end_date: string;
    client_id?: string;
  },
  options?: API.RequestOptions,
) => {
  return request<any>('/api/ga4bg/a5-dashboard', {
    method: 'POST',
    data: params,
    ...options,
    ...getRequestOptionDemoMode(),
  });
};
